// modules
import { setUploadToken } from '@weblite/file'

import { connect } from '$setup/ws'
import { setTwaAuthToken } from '$logic/twaCommunication'
import { getClientUserIdentityToken } from '$logic/auth'
import { removeSignOutByServerAnalyticsEvent } from '$logic/auth/sign-out-analytics'
import { handleUrlToLoadAfterLogin } from '$logic/router'
import { showBaleChannelPromotionDialogAfterSignIn } from '$logic/client-device'

const afterSignIn = () => {
  connect()
  getClientUserIdentityToken().then(setUploadToken)
  setTwaAuthToken()
  removeSignOutByServerAnalyticsEvent()

  handleUrlToLoadAfterLogin()
  showBaleChannelPromotionDialogAfterSignIn()
}

export default afterSignIn
